const ALLOWED_DOMAINS = [
  'socommerz.in',
  'socialcommerz.com',
  'api.socommerz.in',
  'crawl-api.socommerz.in',
  'storage.googleapis.com'
];

export function isAllowedUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return ALLOWED_DOMAINS.some((d) => parsed.hostname === d || parsed.hostname.endsWith('.' + d));
  } catch {
    return false;
  }
}

export function safeWindowOpen(url: string, target: string = '_blank'): void {
  if (isAllowedUrl(url)) {
    window.open(url, target);
  } else {
    // blocked: untrusted URL
  }
}
